/**
 * ============================================================
 * Mining Survey WebGIS
 * Main Entry Point
 * ============================================================
 */

import "leaflet/dist/leaflet.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import "@css/style.css";
import "@css/mobile.css";

import App from "./app.js";

import { initCADDatabase } from "./modules/cad/cad-db.js";

import Track from "./modules/track.js";

import Waypoint from "./modules/waypoint.js";

import AppState from "./core/app.js";
import UI from "./modules/ui.js";
import LayerImport from "./modules/layer-import.js";
import LayerManager from "./modules/layers.js";

import { CADImport } from "./modules/cad/cad-import.js";
import Measurement from "./modules/measurement/measurement.js";

import Camera from "./modules/camera/camera.js";

import Auth from "./modules/auth/auth.js";

// ============================================================
// CAD Engine Status
// ============================================================

function updateCADEngineStatus(
    text,
    state = ""
) {

    const element =
        document.getElementById(
            "cadEngineStatus"
        );


    if (!element) {
        console.warn(
            "[CAD] Status element not found."
        );

        return;
    }


    element.textContent = text;


    element.classList.remove(
        "ready",
        "error"
    );


    if (state) {
        element.classList.add(state);
    }
}

document.addEventListener("DOMContentLoaded", async () => {

    // ========================================================
    // AUTHENTICATION
    // ========================================================

    const loginScreen =
        document.getElementById("loginScreen");

    const loginForm =
        document.getElementById("loginForm");

    const loginError =
        document.getElementById("loginError");

    const btnLogin =
        document.getElementById("btnLogin");
    const registerScreen =
    document.getElementById("registerScreen");

    const btnShowRegister =
        document.getElementById("btnShowRegister");

    const btnShowLogin =
        document.getElementById("btnShowLogin");

    const registerForm =
    document.getElementById("registerForm");

    const registerError =
        document.getElementById("registerError");

    const btnRegister =
        document.getElementById("btnRegister");


    console.log("[AUTH] Checking existing session...");


//View Password
    const loginPassword =
        document.getElementById("loginPassword");

    const toggleLoginPassword =
        document.getElementById("toggleLoginPassword");

    toggleLoginPassword?.addEventListener(
        "click",
        () => {

            const isPassword =
                loginPassword.type === "password";

            loginPassword.type =
                isPassword
                    ? "text"
                    : "password";

            const icon =
                toggleLoginPassword.querySelector("i");

            if (icon) {
                icon.className =
                    isPassword
                        ? "bi bi-eye-slash"
                        : "bi bi-eye";
            }

            toggleLoginPassword.setAttribute(
                "aria-label",
                isPassword
                    ? "Sembunyikan password"
                    : "Tampilkan password"
            );

            toggleLoginPassword.setAttribute(
                "title",
                isPassword
                    ? "Sembunyikan password"
                    : "Tampilkan password"
            );
        }
    );

        // ========================================================
    // AUTH UI STATE
    // ========================================================

    function setAuthUI(loggedIn) {

        if (loggedIn) {

            document.body.classList.remove(
                "auth-locked"
            );

            document.body.classList.add(
                "auth-unlocked"
            );

            loginScreen?.classList.add(
                "hidden"
            );

        } else {

            document.body.classList.remove(
                "auth-unlocked"
            );

            document.body.classList.add(
                "auth-locked"
            );

            loginScreen?.classList.remove(
                "hidden"
            );
        }
    }

    // ========================================================
    // REGISTER SCREEN
    // ========================================================

    btnShowRegister?.addEventListener(
        "click",
        () => {

            loginScreen.style.display = "none";

            if (registerScreen) {
                registerScreen.style.display = "flex";
            }

            console.log("[AUTH] Register screen opened.");
        }
    );


    btnShowLogin?.addEventListener(
        "click",
        () => {

            if (registerScreen) {
                registerScreen.style.display = "none";
            }

            loginScreen.style.display = "";

            console.log("[AUTH] Login screen opened.");
        }
    );


    // ========================================================
    // REGISTER FORM
    // ========================================================

    registerForm?.addEventListener(
        "submit",
        async (event) => {

            event.preventDefault();

            registerError.hidden = true;
            registerError.textContent = "";


            const fullName =
                document
                    .getElementById("registerFullName")
                    .value
                    .trim();


            const departemen =
                document
                    .getElementById("registerDepartment")
                    .value
                    .trim();


            const username =
                document
                    .getElementById("registerUsername")
                    .value
                    .trim();


            const password =
                document
                    .getElementById("registerPassword")
                    .value;


            const passwordConfirm =
                document
                    .getElementById("registerPasswordConfirm")
                    .value;


            // ====================================================
            // VALIDASI
            // ====================================================

            if (
                !fullName ||
                !departemen ||
                !username ||
                !password ||
                !passwordConfirm
            ) {

                registerError.textContent =
                    "Semua field wajib diisi.";

                registerError.hidden = false;

                return;
            }


            if (password !== passwordConfirm) {

                registerError.textContent =
                    "Konfirmasi password tidak sama.";

                registerError.hidden = false;

                return;
            }


            // ====================================================
            // SUBMIT
            // ====================================================

            btnRegister.disabled = true;

            btnRegister.innerHTML =
                `<i class="bi bi-hourglass-split"></i> Mendaftarkan...`;


            try {

                console.log(
                    "[AUTH] Register:",
                    {
                        username,
                        fullName,
                        departemen
                    }
                );


                const result =
                    await Auth.register(
                        username,
                        password,
                        fullName,
                        departemen
                    );


                console.log(
                    "[AUTH] Registrasi berhasil:",
                    result
                );


                // =================================================
                // BERHASIL
                // =================================================

                alert(
                    "Registrasi berhasil. Silakan login."
                );


                // Reset form

                registerForm.reset();


                // Tutup register

                registerScreen.style.display =
                    "none";


                // Tampilkan login

                loginScreen.style.display =
                    "";


                // Fokus username

                document
                    .getElementById("loginUsername")
                    ?.focus();


            } catch (error) {

                console.error(
                    "[AUTH] Registrasi gagal:",
                    error
                );


                registerError.textContent =
                    error.message ||
                    "Registrasi gagal.";


                registerError.hidden =
                    false;


            } finally {

                btnRegister.disabled =
                    false;


                btnRegister.innerHTML =
                    "Daftar";

            }

        }
    );

    // ========================================================
    // CHECK EXISTING SESSION
    // ========================================================

    let session = null;

    try {

        session = await Auth.me();

    } catch (error) {

        console.error(
            "[AUTH] Session check failed:",
            error
        );

        session = null;
    }


    if (session) {

        console.log(
            "[AUTH] Existing session valid:",
            session.user.username
        );

        setAuthUI(true);

    } else {

        console.log(
            "[AUTH] No valid session."
        );

        setAuthUI(false);
    }

    // ========================================================
    // LOGIN FORM
    // ========================================================

    loginForm?.addEventListener(
        "submit",
        async (event) => {

            event.preventDefault();

            loginError.hidden = true;


            const username =
                document
                    .getElementById("loginUsername")
                    .value
                    .trim();


            const password =
                document
                    .getElementById("loginPassword")
                    .value;


            if (!username || !password) {

                loginError.textContent =
                    "Username dan password wajib diisi.";

                loginError.hidden = false;

                return;
            }


            btnLogin.disabled = true;

            btnLogin.innerHTML =
                `<i class="bi bi-hourglass-split"></i> Login...`;


            try {

                const result =
                    await Auth.login(
                        username,
                        password
                    );


                console.log(
                    "[AUTH] Login berhasil:",
                    result.user.username
                );


                setAuthUI(true);

                // Jalankan WebGIS
                startApplication();


            } catch (error) {

                console.error(
                    "[AUTH] Login gagal:",
                    error
                );


                loginError.textContent =
                    error.message ||
                    "Login gagal.";

                loginError.hidden = false;


            } finally {

                btnLogin.disabled = false;

                btnLogin.innerHTML =
                    `<i class="bi bi-box-arrow-in-right"></i> Login`;
            }
        }
    );


    // ========================================================
    // START APPLICATION
    // ========================================================

    function startApplication() {

        // Jangan start dua kali
        if (AppState.applicationStarted) {
            return;
        }

        AppState.applicationStarted = true;

        console.log(
            "[APP] Starting Mining Survey WebGIS..."
        );

        App.start();
    }


// ========================================================
// Initialize DuckDB-WASM
// ========================================================

    
    // ========================================================
    // START APP ONLY AFTER AUTHENTICATION
    // ========================================================

    if (session) {
        startApplication();
    }



    // ========================================================
    // Initialize DuckDB-WASM
    // ========================================================

    const cadStatus = document.getElementById("cadEngineStatus");
    const btnOpenLayer = document.getElementById("btnOpenLayer");

    // Initial state
    if (cadStatus) {
        cadStatus.textContent = "⏳ Import CAD Engine: initializing...";
    }

    if (btnOpenLayer) {
        btnOpenLayer.disabled = true;
    }

    console.log("[APP] Starting DuckDB initialization...");

    initCADDatabase()
        .then(() => {

            console.log("[APP] DuckDB READY");

            updateCADEngineStatus(
                "✓ Import CAD Engine: READY",
                "ready"
            );

            const btn = document.getElementById("btnOpenLayer");

            if (btnOpenLayer) {
                btnOpenLayer.disabled = false;
            }

                    // Hilangkan status setelah 1.5 detik
                    setTimeout(() => {
                        const status = document.getElementById("cadEngineStatus");

                        if (status) {
                            status.style.display = "none";
                        }
                    }, 1000);

        })
        .catch((error) => {

            console.error(
                "[APP] DuckDB initialization failed:",
                error
            );

            updateCADEngineStatus(
                "✕ CAD Engine: ERROR",
                "error"
            );
        });



    // ========================================================
    // Other Application Modules
    // ========================================================

    Measurement.init();
    Camera.init();

    document.getElementById("btnSave")?.addEventListener("click", () => {
        Track.save();
        closeToolbar();
    });

    // ===== Tambahkan ini =====
    document.getElementById("btnWaypoint")?.addEventListener("click", () => {
        UI.showWaypointDialog(`WP-${String(AppState.waypoints.length + 1).padStart(3, "0")}`);
        closeToolbar();
    });

    // ===== Yang ini tetap =====
    document.getElementById("btnWaypointSave")?.addEventListener("click", () => {
        const data = UI.getWaypointForm();

        if (!data.name) {
            alert("Waypoint Name wajib diisi.");

            return;
        }

        const success = Waypoint.add(AppState.currentPosition, data.name, data.description);

        if (success) {
            UI.hideWaypointDialog();
        }
    });

    document.getElementById("btnWaypointCancel")?.addEventListener("click", () => {
        UI.hideWaypointDialog();
    });
    const panel = document.getElementById("layerPanel");
    const backdrop = document.getElementById("panelBackdrop");

    // ==========================
    // Open Layer Panel
    // ==========================

    document.getElementById("btnLayers")?.addEventListener("click", () => {
        panel.classList.add("show");
        backdrop.classList.add("show");
        closeToolbar();
    });

    // ==========================
    // Import Layer
    // ==========================

    document.getElementById("btnOpenLayer")?.addEventListener("click", (e) => {

        e.preventDefault();
        e.stopPropagation();

        const fileInput = document.getElementById("fileImport");

        if (!fileInput) return;

        fileInput.click();

        closeToolbar();
    });

    // ==========================
    // Close Panel
    // ==========================

    function closeLayerPanel() {
        panel.classList.remove("show");
        backdrop.classList.remove("show");
    }

    document.getElementById("btnCloseLayerPanel")?.addEventListener("click", closeLayerPanel);

    // Klik area gelap di luar panel
    backdrop?.addEventListener("click", (e) => {
        if (e.target !== backdrop) return;

        closeLayerPanel();
    });

    // ==========================
    // Import File
    // ==========================

    /**document.getElementById("fileImport")?.addEventListener("change", async (e) => {
        const file = e.target.files[0];

        if (!file) return;

        await LayerImport.open(file);

        e.target.value = "";
    });
    **/
    document.getElementById("fileImport")?.addEventListener("change", async (e) => {

        e.preventDefault();
        e.stopPropagation();

        const input = e.target;
        const file = input.files?.[0];

        if (!file) return;

        console.log("[IMPORT] Selected:", file.name);
        console.log("[IMPORT] Type:", file.type);
        console.log("[IMPORT] Size:", file.size);

        try {

            await LayerImport.open(file);

        } catch (error) {

            console.error("[IMPORT] Failed:", error);

            alert(`Gagal import file:\n${file.name}`);

        } finally {

            // Reset setelah proses selesai
            input.value = "";

        }

    });

    // ==========================
    // Checkbox Visible
    // ==========================

    const layerList = document.getElementById("layerList");

    layerList?.addEventListener("change", (e) => {
        if (!e.target.classList.contains("layer-visible")) return;

        LayerManager.setVisible(e.target.dataset.id, e.target.checked);
    });
    // ==========================
    // Zoom & Delete
    // ==========================

    layerList?.addEventListener("click", (e) => {
        // =====================
        // Zoom
        // =====================

        const zoomBtn = e.target.closest(".layer-zoom");

        if (zoomBtn) {
            LayerManager.zoom(zoomBtn.dataset.id);

            return;
        }

        // =====================
        // Delete
        // =====================

        const removeBtn = e.target.closest(".layer-remove");

        if (removeBtn) {
            if (!confirm("Hapus layer ini?")) return;

            if (LayerManager.remove(removeBtn.dataset.id)) {
                UI.renderLayerList();
            }
        }
    });

    const toolbar = document.getElementById("toolbar");
    const fab = document.getElementById("fabMenu");

    fab?.addEventListener("click", () => {
        toolbar?.classList.toggle("show");
    });

    function closeToolbar() {
        // hanya berlaku di mobile
        if (window.innerWidth <= 768) {
            toolbar.classList.remove("show");
        }
    }

    const sheet = document.getElementById("bottomSheet");

    sheet.addEventListener("click", () => {
        sheet.classList.toggle("expand");
    });

    let startX = 0;

    panel.addEventListener("touchstart", (e) => {
        startX = e.touches[0].clientX;
    });

    panel.addEventListener("touchmove", (e) => {
        const dx = e.touches[0].clientX - startX;

        if (dx > 80) {
            closeLayerPanel();
        }
    });
});
